import React, { useState } from 'react';
import axios from 'axios';
import { Prism as SyntaxHighlighter } from 'react-syntax-highlighter';
import { vscDarkPlus } from 'react-syntax-highlighter/dist/esm/styles/prism';
import { API_URL } from '../config';
import AdSense from './AdSense';
import { sanitizeErrorMessage, validateInputSize } from '../utils/security';

// Set to true when you integrate Google AdSense
const SHOW_ADS = true;

const XmlViewer = () => {
  const [input, setInput] = useState('');
  const [output, setOutput] = useState('');
  const [error, setError] = useState('');
  const [isValid, setIsValid] = useState(null);

  const handleValidate = async () => {
    // SECURITY: Client-side input validation
    if (!input || !input.trim()) {
      setError('Please enter XML data to validate');
      return;
    }

    // SECURITY: Validate input size
    const sizeCheck = validateInputSize(input, 10);
    if (!sizeCheck.valid) {
      setError(sizeCheck.error);
      return;
    }

    try {
      const response = await axios.post(`${API_URL}/validate-xml/`, {
        data: input
      });
      
      if (response.data.valid) {
        setOutput(response.data.formatted);
        setError('');
        setIsValid(true);
      } else {
        // SECURITY: Sanitize error message
        setError(sanitizeErrorMessage(response.data.error));
        setIsValid(false);
        setOutput('');
      }
    } catch (err) {
      // SECURITY: Sanitize error message
      setError(sanitizeErrorMessage(err.response?.data?.error || 'An error occurred'));
      setIsValid(false);
      setOutput('');
    }
  };

  return (
    <div className="viewer-container">
      <div className="input-section">
        <h2>XML Input</h2>
        <textarea
          value={input}
          onChange={(e) => setInput(e.target.value)}
          placeholder='<root><name>John</name><age>30</age></root>'
          className="input-textarea"
        />
        <button onClick={handleValidate} className="validate-btn">
          Validate & Format
        </button>
        {error && <div className="error-message">{error}</div>}
        {isValid && <div className="success-message">✓ Valid XML</div>}
      </div>
      {output && (
        <>
          <div className="output-section">
            <h2>Formatted Output</h2>
            <SyntaxHighlighter language="xml" style={vscDarkPlus}>
              {output}
            </SyntaxHighlighter>
          </div>
          
          {/* In-content Ad - Only visible when SHOW_ADS is true and output is displayed */}
          {SHOW_ADS && (
            <div className="in-content-ad">
              <AdSense
                adFormat="auto"
                style={{ width: '100%', maxWidth: '728px', height: '90px', margin: '2rem auto', display: 'block' }}
                className="ad-incontent"
              />
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default XmlViewer;

